import { TileLayer } from '@deck.gl/geo-layers';

import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

interface CopernicusTileLayerOptions {
  date: string;
  maxCloudCoverage: number;
}

export function copernicusTileLayer({
  date,
  maxCloudCoverage,
}: CopernicusTileLayerOptions): TileLayer {
  const query = new URLSearchParams({
    date,
    cloudCoverage: String(maxCloudCoverage),
    visualization: 'browser-l2a-true-color-v2',
  });

  return new TileLayer({
    id: `copernicus-l2a-true-color-v2-${date}-${maxCloudCoverage}`,
    data: `/copernicus/tiles/{z}/{x}/{y}?${query.toString()}`,
    loadOptions: {
      mimeType: 'image/png',
      fetch: { credentials: 'same-origin' },
    },
    maxRequests: 12,
    minZoom: 0,
    maxZoom: 18,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });
}
